const translationKeys = {
  loans_header_loans_and_credit: 'loans_header_loans_and_credit',
  loans_header_apply_for_a_new_loan: 'loans_header_apply_for_a_new_loan',
  loans_header_loan_calculator: 'loans_header_loan_calculator',
  loans_header_apply_for_proof_of_financing:
    'loans_header_apply_for_proof_of_financing',
  loans_loan_section_consumer_loans_header:
    'loans_loan_section_consumer_loans_header',
  loans_loan_section_mortgage_loans_header:
    'loans_loan_section_mortgage_loans_header',
  loans_loan_section_vehicle_loans_header:
    'loans_loan_section_vehicle_loans_header',
  loans_loan_section_vehicle_loans_error:
    'loans_loan_section_vehicle_loans_error',
  loans_loan_section_credit_loans_header:
    'loans_loan_section_credit_loans_header',
  loans_loan_section_account_balance_error:
    'loans_loan_section_account_balance_error',
  loans_loan_details_header_extra_payment:
    'loans_loan_details_header_extra_payment',
  loans_loan_details_header_deductible: 'loans_loan_details_header_deductible',
  loans_loan_details_header_breadcrumb_loans_and_credit:
    'loans_loan_details_header_breadcrumb_loans_and_credit',
  loans_loan_details_header_remaining_loan:
    'loans_loan_details_header_remaining_loan',
  loans_loan_details_header_account_details_error:
    'loans_loan_details_header_account_details_error',
  loans_loan_details_linked_to_section_header:
    'loans_loan_details_linked_to_section_header',
  loans_loan_details_repayment_plan_section_header:
    'loans_loan_details_repayment_plan_section_header',
  loans_suggestion_card_button: 'loans_suggestion_card_button',
  loans_suggestion_card_consumer_loans_header:
    'loans_suggestion_card_consumer_loans_header',
  loans_suggestion_card_consumer_loans_footer:
    'loans_suggestion_card_consumer_loans_footer',
  loans_suggestion_card_consumer_loans_footer_link:
    'loans_suggestion_card_consumer_loans_footer_link',
  loans_suggestion_card_consumer_loans_img_alt:
    'loans_suggestion_card_consumer_loans_img_alt',
  loans_suggestion_card_consumer_loans_content:
    'loans_suggestion_card_consumer_loans_content',
  loans_suggestion_card_mortgage_loans_header:
    'loans_suggestion_card_mortgage_loans_header',
  loans_suggestion_card_mortgage_loans_footer:
    'loans_suggestion_card_mortgage_loans_footer',
  loans_suggestion_card_mortgage_loans_footer_link:
    'loans_suggestion_card_mortgage_loans_footer_link',
  loans_suggestion_card_mortgage_loans_img_alt:
    'loans_suggestion_card_mortgage_loans_img_alt',
  loans_suggestion_card_mortgage_loans_content:
    'loans_suggestion_card_mortgage_loans_content',
  loans_suggestion_card_car_loans_header:
    'loans_suggestion_card_car_loans_header',
  loans_suggestion_card_car_loans_footer:
    'loans_suggestion_card_car_loans_footer',
  loans_suggestion_card_car_loans_footer_link:
    'loans_suggestion_card_car_loans_footer_link',
  loans_suggestion_card_car_loans_img_alt:
    'loans_suggestion_card_car_loans_img_alt',
  loans_suggestion_card_car_loans_content:
    'loans_suggestion_card_car_loans_content',
  loans_suggestion_section_header: 'loans_suggestion_section_header',
  loans_loan_details_header_download_as_pdf:
    'loans_loan_details_header_download_as_pdf',
  loans_loan_section_subtitle_total_debt:
    'loans_loan_section_subtitle_total_debt',
  loans_loan_section_accounts_error: 'loans_loan_section_accounts_error',
  loans_vehicle_loan_details_header_section_title:
    'loans_vehicle_loan_details_header_section_title',
  loans_vehicle_loan_details_original_vehicle_price:
    'loans_vehicle_loan_details_original_vehicle_price',
  loans_vehicle_loan_details_due_date: 'loans_vehicle_loan_details_due_date',
  loans_vehicle_loan_details_payment_installment:
    'loans_vehicle_loan_details_payment_installment',
  loans_vehicle_loan_details_account_number:
    'loans_vehicle_loan_details_account_number',
  loans_vehicle_loan_details_start_date:
    'loans_vehicle_loan_details_start_date',
  loans_vehicle_loan_details_description:
    'loans_vehicle_loan_details_description',
  loans_loan_details_credit_card_account_number:
    'loans_loan_details_credit_card_account_number',
  loans_loan_details_credit_card_direct_debit_agreement:
    'loans_loan_details_credit_card_direct_debit_agreement',
  loans_loan_details_credit_card_direct_debit_agreement_on:
    'loans_loan_details_credit_card_direct_debit_agreement_on',
  loans_loan_details_credit_card_direct_debit_agreement_off:
    'loans_loan_details_credit_card_direct_debit_agreement_off',
  loans_loan_details_credit_card_opening_date:
    'loans_loan_details_credit_card_opening_date',
  loans_vehicle_loan_details_error_message:
    'loans_vehicle_loan_details_error_message',
  loans_header_total_debt_error: 'loans_header_total_debt_error',
  loans_loan_details_page_debtor_section_title:
    'loans_loan_details_page_debtor_section_title',
  loans_loan_details_header_account_balance_error:
    'loans_loan_details_header_account_balance_error',
  loans_loan_details_person_cell_subtitle_role_owner:
    'loans_loan_details_person_cell_subtitle_role_owner',
  loans_loan_details_person_cell_subtitle_role_co_borrower:
    'loans_loan_details_person_cell_subtitle_role_co_borrower',
  loans_loan_details_person_cell_subtitle_role_third_party_user:
    'loans_loan_details_person_cell_subtitle_role_third_party_user',
  loans_loan_details_person_cell_subtitle_role_third_party_recipient:
    'loans_loan_details_person_cell_subtitle_role_third_party_recipient',
  loans_loan_details_person_cell_subtitle_role_landlord:
    'loans_loan_details_person_cell_subtitle_role_landlord',
  loans_loan_details_person_cell_subtitle_role_guarantor:
    'loans_loan_details_person_cell_subtitle_role_guarantor',
  loans_loan_details_person_cell_subtitle_role_guardian:
    'loans_loan_details_person_cell_subtitle_role_guardian',
  loans_loan_details_person_cell_subtitle_role_assistant_guardian:
    'loans_loan_details_person_cell_subtitle_role_assistant_guardian',
  loans_loan_details_page_debtor_section_error:
    'loans_loan_details_page_debtor_section_error',
  loans_loan_details_header_alternatives_loan_information:
    'loans_loan_details_header_alternatives_loan_information',
  loans_loan_details_header_paid: 'loans_loan_details_header_paid',
  loans_loan_details_header_of_total: 'loans_loan_details_header_of_total',
  loans_loan_details_header_remaining_loan_period_year:
    'loans_loan_details_header_remaining_loan_period_year',
  loans_loan_details_header_remaining_loan_period_month:
    'loans_loan_details_header_remaining_loan_period_month',
  loans_loan_details_header_remaining_loan_period:
    'loans_loan_details_header_remaining_loan_period',
  loans_loan_details_overview_nominal_interest_rate_help_title:
    'loans_loan_details_overview_nominal_interest_rate_help_title',
  loans_loan_details_overview_nominal_interest_rate:
    'loans_loan_details_overview_nominal_interest_rate',
  loans_loan_details_overview_nominal_interest_rate_help_text:
    'loans_loan_details_overview_nominal_interest_rate_help_text',
  loans_loan_details_overview_nominal_interest_rate_change_date:
    'loans_loan_details_overview_nominal_interest_rate_change_date',
  loans_loan_details_overview_next_payment:
    'loans_loan_details_overview_next_payment',
  loans_loan_details_overview_remaining_loan_time:
    'loans_loan_details_overview_remaining_loan_time',
  loans_loan_details_overview_error_message:
    'loans_loan_details_overview_error_message',
  loans_loan_details_header_remaining_loan_period_days:
    'loans_loan_details_header_remaining_loan_period_days',
  loans_loan_details_header_alternatives:
    'loans_loan_details_header_alternatives',
  loans_loan_details_linked_to_section_address:
    'loans_loan_details_linked_to_section_address',
  loans_loan_details_linked_to_section_mortgage_rate:
    'loans_loan_details_linked_to_section_mortgage_rate',
  loans_loan_details_linked_to_section_estimated_value:
    'loans_loan_details_linked_to_section_estimated_value',
  loans_loan_details_linked_to_section_mortgage_rate_help_title:
    'loans_loan_details_linked_to_section_mortgage_rate_help_title',
  loans_loan_details_information_header:
    'loans_loan_details_information_header',
  loans_loan_details_information_about_loan_title:
    'loans_loan_details_information_about_loan_title',
  loans_loan_details_information_about_loan_opening_date:
    'loans_loan_details_information_about_loan_opening_date',
  loans_loan_details_information_about_loan_alias:
    'loans_loan_details_information_about_loan_alias',
  loans_loan_details_information_about_loan_original_loan_abount:
    'loans_loan_details_information_about_loan_original_loan_abount',
  loans_loan_details_information_about_loan_remaining_debt:
    'loans_loan_details_information_about_loan_remaining_debt',
  loans_loan_details_information_about_loan_remaining_time:
    'loans_loan_details_information_about_loan_remaining_time',
  loans_loan_debt_access_consent_title: 'loans_loan_debt_access_consent_title',
  loans_loan_debt_access_consent_subtitle:
    'loans_loan_debt_access_consent_subtitle',
  loans_loan_details_information_loan_conditions_title:
    'loans_loan_details_information_loan_conditions_title',
  loans_loan_details_information_nominal_interest_rate:
    'loans_loan_details_information_nominal_interest_rate',
  loans_loan_details_information_repayment_method:
    'loans_loan_details_information_repayment_method',
  loans_loan_details_information_interest_rate_type:
    'loans_loan_details_information_interest_rate_type',
  loans_loan_details_information_repayment_method_serial:
    'loans_loan_details_information_repayment_method_serial',
  loans_loan_details_information_repayment_method_annuity:
    'loans_loan_details_information_repayment_method_annuity',
  loans_loan_details_information_interest_rate_type_fixed:
    'loans_loan_details_information_interest_rate_type_fixed',
  loans_loan_details_information_interest_rate_type_floating:
    'loans_loan_details_information_interest_rate_type_floating',
  loans_loan_details_information_nominal_interest_rate_description:
    'loans_loan_details_information_nominal_interest_rate_description',
  loans_loan_details_information_payment_details_title:
    'loans_loan_details_information_payment_details_title',
  loans_loan_details_information_payment_date:
    'loans_loan_details_information_payment_date',
  loans_loan_details_information_payment_account:
    'loans_loan_details_information_payment_account',
  loans_loan_details_information_installment:
    'loans_loan_details_information_installment',
  loans_loan_details_information_international_payment_title:
    'loans_loan_details_information_international_payment_title',
  loans_loan_details_information_iban: 'loans_loan_details_information_iban',
  loans_loan_details_information_bic: 'loans_loan_details_information_bic',
  loans_loan_details_information_iban_description:
    'loans_loan_details_information_iban_description',
  loans_loan_details_information_bic_description:
    'loans_loan_details_information_bic_description',
  loans_loan_details_information_account_number:
    'loans_loan_details_information_account_number',
  loans_loan_details_information_international_payment_account:
    'loans_loan_details_information_international_payment_account',
  loans_loan_details_credit_card_details_section_header:
    'loans_loan_details_credit_card_details_section_header',
  loans_loan_details_linked_to_error_message:
    'loans_loan_details_linked_to_error_message',
  loans_loan_details_repayment_plan_button:
    'loans_loan_details_repayment_plan_button',
  loans_loan_details_lates_transactions_button:
    'loans_loan_details_lates_transactions_button',
  loans_loan_details_header_breadcrumb_home_page:
    'loans_loan_details_header_breadcrumb_home_page',
  loans_loan_header_section_breadcrumb_home_page:
    'loans_loan_header_section_breadcrumb_home_page',
  loans_loan_details_header_increase_loan:
    'loans_loan_details_header_increase_loan',
  loans_loan_section_pre_qualification_title:
    'loans_loan_section_pre_qualification_title',
  loans_loan_section_pre_qualification_purpose_freehold:
    'loans_loan_section_pre_qualification_purpose_freehold',
  loans_loan_section_pre_qualification_purpose_condominium:
    'loans_loan_section_pre_qualification_purpose_condominium',
  loans_loan_section_pre_qualification_expire:
    'loans_loan_section_pre_qualification_expire',
  loans_loan_section_pre_qualification_purpose_unknown:
    'loans_loan_section_pre_qualification_purpose_unknown',
  loans_pre_qualification_secondary_section_expiration_date:
    'loans_pre_qualification_secondary_section_expiration_date',
  loans_pre_qualification_participants_title:
    'loans_pre_qualification_participants_title',
  loans_pre_qualification_details_accordion_equity_cell_equity_title:
    'loans_pre_qualification_details_accordion_equity_cell_equity_title',
  loans_pre_qualification_details_title:
    'loans_pre_qualification_details_title',
  loans_pre_qualification_infocard_broker_description:
    'loans_pre_qualification_infocard_broker_description',
  loans_pre_qualification_details_accordion_purchase_amount_cell_loan_title:
    'loans_pre_qualification_details_accordion_purchase_amount_cell_loan_title',
  loans_pre_qualification_shortcuts_cell_checklist_title:
    'loans_pre_qualification_shortcuts_cell_checklist_title',
  loans_pre_qualification_header_title: 'loans_pre_qualification_header_title',
  loans_pre_qualification_header_description:
    'loans_pre_qualification_header_description',
  loans_pre_qualification_details_accordion_equity_cell_other_costs_subtitle:
    'loans_pre_qualification_details_accordion_equity_cell_other_costs_subtitle',
  loans_pre_qualification_details_accordion_purchase_amount_cell_max_amount_title:
    'loans_pre_qualification_details_accordion_purchase_amount_cell_max_amount_title',
  loans_pre_qualification_details_accordion_equity_cell_total_equity_title:
    'loans_pre_qualification_details_accordion_equity_cell_total_equity_title',
  loans_pre_qualification_info_card_bidding_win_description:
    'loans_pre_qualification_info_card_bidding_win_description',
  loans_pre_qualification_details_accordion_purchase_amount_cell_total_equity_title:
    'loans_pre_qualification_details_accordion_purchase_amount_cell_total_equity_title',
  loans_pre_qualification_header_button_more_actions:
    'loans_pre_qualification_header_button_more_actions',
  loans_pre_qualification_shortcuts_cell_edit_pre_qualification_title:
    'loans_pre_qualification_shortcuts_cell_edit_pre_qualification_title',
  loans_pre_qualification_infocard_bidding_win_title:
    'loans_pre_qualification_infocard_bidding_win_title',
  loans_pre_qualification_secondary_section_purpose:
    'loans_pre_qualification_secondary_section_purpose',
  loans_pre_qualification_details_accordion_equity_cell_other_costs_title:
    'loans_pre_qualification_details_accordion_equity_cell_other_costs_title',
  loans_pre_qualification_details_accordion_equity_cell_bound_equity_title:
    'loans_pre_qualification_details_accordion_equity_cell_bound_equity_title',
  loans_pre_qualification_header_button_download:
    'loans_pre_qualification_header_button_download',
  loans_pre_qualification_details_accordion_equity_title:
    'loans_pre_qualification_details_accordion_equity_title',
  loans_pre_qualification_details_accordion_purchase_amount_cell_max_amount_subtitle:
    'loans_pre_qualification_details_accordion_purchase_amount_cell_max_amount_subtitle',
  loans_pre_qualification_header_button_edit:
    'loans_pre_qualification_header_button_edit',
  loans_pre_qualification_infocard_broker_title:
    'loans_pre_qualification_infocard_broker_title',
  loans_pre_qualification_shortcuts_title:
    'loans_pre_qualification_shortcuts_title',
  loans_pre_qualification_details_accordion_purchase_amount_title:
    'loans_pre_qualification_details_accordion_purchase_amount_title',
  loans_pre_qualification_shortcuts_cell_bidding_tips_title:
    'loans_pre_qualification_shortcuts_cell_bidding_tips_title',
  loans_pre_qualification_shortcuts_cell_properties_for_sale_title:
    'loans_pre_qualification_shortcuts_cell_properties_for_sale_title',
  loans_pre_qualification_info_pre_qualification_title:
    'loans_pre_qualification_info_pre_qualification_title',
  loans_pre_qualification_info_pre_qualification_bullet1:
    'loans_pre_qualification_info_pre_qualification_bullet1',
  loans_pre_qualification_info_pre_qualification_bullet3:
    'loans_pre_qualification_info_pre_qualification_bullet3',
  loans_pre_qualification_info_maxamount_body:
    'loans_pre_qualification_info_maxamount_body',
  loans_pre_qualification_info_hero_title:
    'loans_pre_qualification_info_hero_title',
  loans_pre_qualification_info_max_amount_title:
    'loans_pre_qualification_info_max_amount_title',
  loans_pre_qualification_info_withdrawal_title:
    'loans_pre_qualification_info_withdrawal_title',
  loans_pre_qualification_info_pre_qualification_bullet2:
    'loans_pre_qualification_info_pre_qualification_bullet2',
  loans_pre_qualification_info_withdrawal_body:
    'loans_pre_qualification_info_withdrawal_body',
  loans_pre_qualification_header_button_delete:
    'loans_pre_qualification_header_button_delete',
  loans_pre_qualification_header_button_about:
    'loans_pre_qualification_header_button_about',
  loans_pre_qualification_secondary_section_expiration_warning:
    'loans_pre_qualification_secondary_section_expiration_warning',
  loans_pre_qualification_secondary_section_purpose_info_condominium:
    'loans_pre_qualification_secondary_section_purpose_info_condominium',
  loans_pre_qualification_header_breadcrumb_home_page:
    'loans_pre_qualification_header_breadcrumb_home_page',
  loans_pre_qualification_header_breadcrumb_loans_and_credit:
    'loans_pre_qualification_header_breadcrumb_loans_and_credit',
  loans_loan_section_pre_qualification_button_closed:
    'loans_loan_section_pre_qualification_button_closed',
  loans_loan_section_pre_qualification_button_expanded:
    'loans_loan_section_pre_qualification_button_expanded',
  loans_loan_section_pre_qualification_letter_error_state:
    'loans_loan_section_pre_qualification_letter_error_state',
  loans_loan_section_student_loan_title:
    'loans_loan_section_student_loan_title',
  loans_loan_section_student_loan_description:
    'loans_loan_section_student_loan_description',
  loans_loan_section_student_loan_activate_button:
    'loans_loan_section_student_loan_activate_button',
  loans_loan_section_student_loan_dismiss_button:
    'loans_loan_section_student_loan_dismiss_button',
  loans_loan_section_other_loans_header:
    'loans_loan_section_other_loans_header',
  loans_loan_section_other_loans_opt_in:
    'loans_loan_section_other_loans_opt_in',
  loans_loan_section_nogi_description: 'loans_loan_section_nogi_description',
  loans_nogi_credit_card_header_available_balance:
    'loans_nogi_credit_card_header_available_balance',
  loans_nogi_credit_card_header_reserved:
    'loans_nogi_credit_card_header_reserved',
  loans_nogi_credit_card_header_credit_limit:
    'loans_nogi_credit_card_header_credit_limit',
  loans_nogi_credit_card_information_general_credit_limit:
    'loans_nogi_credit_card_information_general_credit_limit',
  loans_nogi_credit_card_information_general_balance:
    'loans_nogi_credit_card_information_general_balance',
  loans_nogi_credit_card_information_general_title:
    'loans_nogi_credit_card_information_general_title',
  loans_nogi_credit_card_information_general_available_amount:
    'loans_nogi_credit_card_information_general_available_amount',
  loans_nogi_credit_card_information_general_name:
    'loans_nogi_credit_card_information_general_name',
  loans_nogi_credit_card_information_header:
    'loans_nogi_credit_card_information_header',
  loans_nogi_credit_card_information_conditions_title:
    'loans_nogi_credit_card_information_conditions_title',
  loans_nogi_credit_card_information_conditions_nominal_interest_rate:
    'loans_nogi_credit_card_information_conditions_nominal_interest_rate',
  loans_nogi_credit_card_information_conditions_payment_period:
    'loans_nogi_credit_card_information_conditions_payment_period',
  loans_nogi_credit_card_information_conditions_monthly_fees:
    'loans_nogi_credit_card_information_conditions_monthly_fees',
  loans_nogi_credit_card_information_conditions_description:
    'loans_nogi_credit_card_information_conditions_description',
  loans_nogi_charge_card_header_recerved:
    'loans_nogi_charge_card_header_recerved',
  loans_nogi_charge_card_header_information_button:
    'loans_nogi_charge_card_header_information_button',
  loans_nogi_charge_card_header_balance:
    'loans_nogi_charge_card_header_balance',
  loans_nogi_charge_card_header_credit_limit:
    'loans_nogi_charge_card_header_credit_limit',
  loans_nogi_charge_card_header_available_balance:
    'loans_nogi_charge_card_header_available_balance',
  loans_nogi_charge_card_information_general_credit_limit:
    'loans_nogi_charge_card_information_general_credit_limit',
  loans_nogi_charge_card_information_general_available_balance:
    'loans_nogi_charge_card_information_general_available_balance',
  loans_nogi_charge_card_information_header:
    'loans_nogi_charge_card_information_header',
  loans_nogi_charge_card_information_general_balance:
    'loans_nogi_charge_card_information_general_balance',
  loans_nogi_charge_card_information_general_name:
    'loans_nogi_charge_card_information_general_name',
  loans_nogi_charge_card_information_general_title:
    'loans_nogi_charge_card_information_general_title',
  loans_nogi_charge_card_information_conditions_title:
    'loans_nogi_charge_card_information_conditions_title',
  loans_nogi_charge_card_information_conditions_description:
    'loans_nogi_charge_card_information_conditions_description',
  loans_nogi_charge_card_information_conditions_monthly_fees:
    'loans_nogi_charge_card_information_conditions_monthly_fees',
  loans_nogi_charge_card_information_conditions_nominal_interest_rate:
    'loans_nogi_charge_card_information_conditions_nominal_interest_rate',
  loans_nogi_charge_card_information_conditions_payment_period:
    'loans_nogi_charge_card_information_conditions_payment_period',
  loans_open_unsecured_loan_application_header:
    'loans_open_unsecured_loan_application_header',
  loans_open_unsecured_loan_application_loan_amount_label:
    'loans_open_unsecured_loan_application_loan_amount_label',
  loans_open_unsecured_loan_application_down_payment_dropdown_label:
    'loans_open_unsecured_loan_application_down_payment_dropdown_label',
  loans_open_unsecured_loan_application_down_payment_dropdown_placeholder:
    'loans_open_unsecured_loan_application_down_payment_dropdown_placeholder',
  loans_open_unsecured_loan_application_down_payment_estimate:
    'loans_open_unsecured_loan_application_down_payment_estimate',
  loans_open_unsecured_loan_application_apply_button:
    'loans_open_unsecured_loan_application_apply_button',
  loans_open_unsecured_loan_application_loan_amount:
    'loans_open_unsecured_loan_application_loan_amount',
  loans_open_unsecured_loan_application_loading_text:
    'loans_open_unsecured_loan_application_loading_text',
  loans_pre_qualification_letter_error_state_title:
    'loans_pre_qualification_letter_error_state_title',
  loans_pre_qualification_letter_error_state_message:
    'loans_pre_qualification_letter_error_state_message',
  loans_loan_details_latest_transactions_header_title:
    'loans_loan_details_latest_transactions_header_title',
  loans_loan_details_latest_transactions_error_state_title:
    'loans_loan_details_latest_transactions_error_state_title',
  loans_loan_details_latest_transactions_error_state_message:
    'loans_loan_details_latest_transactions_error_state_message',
  loans_loan_details_latest_transactions_empty_state:
    'loans_loan_details_latest_transactions_empty_state',
  loans_loan_details_latest_transactions_empty_state_image_alt:
    'loans_loan_details_latest_transactions_empty_state_image_alt',
  loans_loan_details_latest_transactions_details_header_title:
    'loans_loan_details_latest_transactions_details_header_title',
  loans_loan_details_latest_transactions_details_receipt_amount:
    'loans_loan_details_latest_transactions_details_receipt_amount',
  loans_loan_details_latest_transactions_details_receipt_credit_account:
    'loans_loan_details_latest_transactions_details_receipt_credit_account',
  loans_loan_details_latest_transactions_details_receipt_kid:
    'loans_loan_details_latest_transactions_details_receipt_kid',
  loans_loan_details_latest_transactions_details_receipt_booked:
    'loans_loan_details_latest_transactions_details_receipt_booked',
  loans_loan_details_latest_transactions_details_error_state_title:
    'loans_loan_details_latest_transactions_details_error_state_title',
  loans_loan_details_latest_transactions_details_error_state_message:
    'loans_loan_details_latest_transactions_details_error_state_message',
  loans_loan_details_latest_transactions_details_header_breadcrumb:
    'loans_loan_details_latest_transactions_details_header_breadcrumb',
  loans_loan_details_latest_transactions_header_download_pdf_button:
    'loans_loan_details_latest_transactions_header_download_pdf_button',
  loans_loan_details_latest_transactions_header_dropdown_option_view_all:
    'loans_loan_details_latest_transactions_header_dropdown_option_view_all',
  loans_loan_details_latest_transactions_header_dropdown_label:
    'loans_loan_details_latest_transactions_header_dropdown_label',
  loans_header_total_credit_limit_error:
    'loans_header_total_credit_limit_error',
  loans_loan_section_subtitle_total_credit_limit:
    'loans_loan_section_subtitle_total_credit_limit',
  loans_breadcrumb_pre_qualification_letter:
    'loans_breadcrumb_pre_qualification_letter',
  loans_breadcrumb_loans_and_credit: 'loans_breadcrumb_loans_and_credit',
  loans_pre_qualification_info_surety_title:
    'loans_pre_qualification_info_surety_title',
  loans_pre_qualification_info_surety_body:
    'loans_pre_qualification_info_surety_body',
  loans_pre_qualification_info_bridge_loan_body:
    'loans_pre_qualification_info_bridge_loan_body',
  loans_pre_qualification_info_bridge_loan_title:
    'loans_pre_qualification_info_bridge_loan_title',
  loans_pre_qualification_details_accordion_monthly_cost_title:
    'loans_pre_qualification_details_accordion_monthly_cost_title',
  loans_pre_qualification_details_accordion_monthly_cost_example_1_title:
    'loans_pre_qualification_details_accordion_monthly_cost_example_1_title',
  loans_pre_qualification_details_accordion_monthly_cost_description:
    'loans_pre_qualification_details_accordion_monthly_cost_description',
  loans_pre_qualification_details_accordion_monthly_cost_example_1_description:
    'loans_pre_qualification_details_accordion_monthly_cost_example_1_description',
  loans_pre_qualification_details_accordion_monthly_cost_bullet_nominal_interest_rate:
    'loans_pre_qualification_details_accordion_monthly_cost_bullet_nominal_interest_rate',
  loans_pre_qualification_details_accordion_monthly_cost_bullet_effective_interest_rate:
    'loans_pre_qualification_details_accordion_monthly_cost_bullet_effective_interest_rate',
  loans_pre_qualification_details_accordion_monthly_cost_bullet_loan_type:
    'loans_pre_qualification_details_accordion_monthly_cost_bullet_loan_type',
  loans_pre_qualification_details_accordion_monthly_cost_bullet_downpayment_time:
    'loans_pre_qualification_details_accordion_monthly_cost_bullet_downpayment_time',
  loans_pre_qualification_details_accordion_monthly_cost_example_1_conclution:
    'loans_pre_qualification_details_accordion_monthly_cost_example_1_conclution',
  loans_pre_qualification_details_accordion_monthly_cost_example_2_title:
    'loans_pre_qualification_details_accordion_monthly_cost_example_2_title',
  loans_pre_qualification_details_accordion_monthly_cost_example_2_description:
    'loans_pre_qualification_details_accordion_monthly_cost_example_2_description',
  loans_pre_qualification_details_accordion_monthly_cost_example_2_conclution:
    'loans_pre_qualification_details_accordion_monthly_cost_example_2_conclution',
  loans_pre_qualification_details_accordion_monthly_cost_messagebox:
    'loans_pre_qualification_details_accordion_monthly_cost_messagebox',
  loans_pre_qualification_details_accordion_monthly_cost_more_examples_text:
    'loans_pre_qualification_details_accordion_monthly_cost_more_examples_text',
  loans_pre_qualification_details_accordion_monthly_cost_more_examples_link:
    'loans_pre_qualification_details_accordion_monthly_cost_more_examples_link',
};

Object.freeze(translationKeys);

export default translationKeys;
